
<div class="icon-cont custom-flex-center">
  <a class="social-icon" target="_blank" rel="noopener" href="{{componentData.url}}" role="button">
      <i class="sg-icon sg-icon-facebook"></i>
  </a>
      </div>
